import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteNavAnchor, PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import {
    AlWpTest
} from 'PatientCareCenter/Note/WorkProgram/AL';
import { AlTemplate } from 'PatientCareCenter/Note/AL';
class PatientCareCenterNoteWpAL extends React.Component {


    handleClear() {
        this.props.clearAl(this.props.noteId);
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='al' name='Activity Log' showClear={false} onClear={() => this.handleClear()} refProp={this.props.refProp} level={5}>
                  <AlTemplate />
                <PatientCareCenterNoteNavAnchor id='al_wp'>
                    <AlWpTest className={this.props.className} />
                </PatientCareCenterNoteNavAnchor>
            </PatientCareCenterNoteSection>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearAl: bindActionCreators(noteActions.clearAl, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled;

    return {
        noteId: noteId,
        isSpeech,
        className: 'wp'
    };
}

const connectedPatientCareCenterNoteWpAL = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteWpAL);
export { connectedPatientCareCenterNoteWpAL as PatientCareCenterNoteWpAL };

